import { render } from "./CreateTemplate.vue?vue&type=template&id=60f16479&scoped=true"
import script from "./CreateTemplate.vue?vue&type=script&lang=js"
export * from "./CreateTemplate.vue?vue&type=script&lang=js"

import "./CreateTemplate.vue?vue&type=style&index=0&id=60f16479&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.22.1.1/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60f16479"]])

export default __exports__